import React, { useCallback } from 'react';

import { AppUserProviderProps } from './AppUserProvider.types';
import { WisaUserProvider, KeycloakResponseMode} from '../WisaUserMgmt';

import { Routes } from '../../Routes';
import { AppEnvironmentService } from '../../api/environment';

export const AppUserProvider: React.FC<AppUserProviderProps> = ({ children }) => {

  const getKeycloak = useCallback(() => {
    return AppEnvironmentService.getKeycloakEnv();
  },[]);
  return (
    <WisaUserProvider
      logoutRoute={Routes.Home}
      responseMode={KeycloakResponseMode.Hash}
      getKeycloakInitOptions={getKeycloak}
      renderLoading={() => <div></div>}
    >
      {children}
    </WisaUserProvider>
  );
};
